import { defaultVertexShader } from '.'

const grayscaleFragmentSource = `
    precision mediump float;
    
    varying vec2 v_texcoord;
    
    uniform float u_intensity;
    uniform float u_progress;
    uniform sampler2D u_texture;

    const float grain_intensity = 0.12;

    float random(vec2 p) {
        vec2 K1 = vec2(23.14069263277926, 2.665144142690225);
        return fract(cos(dot(p, K1)) * 12345.6789);
    }
    
    void main() {
        float progress = 0.1 + (u_progress * 0.9);
        vec4 color = texture2D(u_texture, v_texcoord);
        vec3 greyScale = vec3(.5, .5, .5);
        vec4 gray = vec4(vec3(dot(color.rgb, greyScale)), color.a);
        vec2 uvRandom = v_texcoord * vec2(progress, 1.0);
        uvRandom.y *= random(vec2(uvRandom.y, 0.2));
        color.rgb += random(uvRandom) * grain_intensity;
        gray.rgb += random(uvRandom) * grain_intensity;
        gl_FragColor = mix(color, gray, u_intensity);
    }
`

export const grayscaleShaderSource = {
    fragment: grayscaleFragmentSource,
    vertex: defaultVertexShader,
}
